import { ICartProduct } from 'models';
import CartProduct from './CartProduct';
import { useI18n } from 'contexts/i18n-context';

import * as S from './style';

interface IProps {
  products: ICartProduct[];
}

const getCartProductKey = (product: ICartProduct) =>
  product.sku ?? product.id;

const CartProducts = ({ products }: IProps) => {
  const { t } = useI18n();

  return (
    <S.Container>
      {products?.length ? (
        products.map((p) => (
          <CartProduct product={p} key={getCartProductKey(p)} />
        ))
      ) : (
        <S.CartProductsEmpty>{t('cart.empty')}</S.CartProductsEmpty>
      )}
    </S.Container>
  );
};

export default CartProducts;
